/**
 * Имя игрока со ссылкой на его страницу.
 *
 * Имена встречаются в комнате, в итогах, в лидербордах и на карточках квестов,
 * и везде это один и тот же жест: посмотреть, кто это. Раньше ссылкой они были
 * через раз, и предугадать, где сработает клик, было невозможно.
 *
 * Без идентификатора ссылки нет: имя остаётся текстом, а не ведёт в никуда.
 */
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface Props {
  userId?: string;
  username?: string;
  className?: string;
  children?: ReactNode;
}

export function PlayerLink({ userId, username, className = "", children }: Props) {
  const content = children ?? username;

  if (!userId) {
    return <span className={className}>{content}</span>;
  }

  return (
    <Link
      to={`/players/${userId}`}
      className={`transition-colors hover:text-amber-300 ${className}`}
      title={username}
    >
      {content}
    </Link>
  );
}
